module.exports = __webpack_public_path__ + "img/logo_revista_governanca_grande.93942c41.png";